module.exports = __webpack_public_path__ + "static/media/fnb.24dbf6a0.png";